module.exports = "/images/s.png?c073506d7185512da38150cc77528d0f";


//////////////////
// WEBPACK FOOTER
// ./resources/js/components/img/s.png
// module id = 2ByM
// module chunks = 70